<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="card" v-if="user">
        <div class="card-body">
          <p class="text-primary font-24">{{ $lang.messages.hello }}, <strong>{{ user.name }}</strong></p>

          <p class="text-grey font-18 m-b-10">{{ $lang.messages.need_some_help }}</p>

          <p class="font-20 m-b-20">{{ $lang.messages.feel_free_contact }}</p>

          <div class="contact">
            <div class="contact__item">
              <a href="tel:1500465">
                <p class="mb-0 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 473.806 473.806">
                    <g xmlns="http://www.w3.org/2000/svg">
                      <path d="M374.456 293.506c-9.7-10.1-21.4-15.5-33.8-15.5-12.3 0-24.1 5.3-34.2 15.4l-31.6 31.5c-2.6-1.4-5.2-2.7-7.7-4-3.6-1.8-7-3.5-9.9-5.3-29.6-18.8-56.5-43.3-82.3-75-12.5-15.8-20.9-29.1-27-42.6 8.2-7.5 15.8-15.3 23.2-22.8 2.8-2.8 5.6-5.7 8.4-8.5 21-21 21-48.2 0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5-6-6.2-12.3-12.6-18.8-18.6-9.7-9.6-21.3-14.7-33.5-14.7s-24 5.1-34 14.7l-.2.2-34 34.3c-12.8 12.8-20.1 28.4-21.7 46.5-2.4 29.2 6.2 56.4 12.8 74.2 16.2 43.7 40.4 84.2 76.5 127.6 43.8 52.3 96.5 93.6 156.7 122.7 23 10.9 53.7 23.8 88 26 2.1.1 4.3.2 6.3.2 23.1 0 42.5-8.3 57.7-24.8.1-.2.3-.3.4-.5 5.2-6.3 11.2-12 17.5-18.1 4.3-4.1 8.7-8.4 13-12.9 9.9-10.3 15.1-22.3 15.1-34.6 0-12.4-5.3-24.3-15.4-34.3l-54.9-55.1zm35.8 105.3c-.1 0-.1.1 0 0-3.9 4.2-7.9 8-12.2 12.2-6.5 6.2-13.1 12.7-19.3 20-10.1 10.8-22 15.9-37.6 15.9-1.5 0-3.1 0-4.6-.1-29.7-1.9-57.3-13.5-78-23.4-56.6-27.4-106.3-66.3-147.6-115.6-34.1-41.1-56.9-79.1-72-119.9-9.3-24.9-12.7-44.3-11.2-62.6 1-11.7 5.5-21.4 13.8-29.7l34.1-34.1c4.9-4.6 10.1-7.1 15.2-7.1 6.3 0 11.4 3.8 14.6 7l.3.3c6.1 5.7 11.9 11.6 18 17.9 3.1 3.2 6.3 6.4 9.5 9.7l27.3 27.3c10.6 10.6 10.6 20.4 0 31-2.9 2.9-5.7 5.8-8.6 8.6-8.4 8.6-16.4 16.6-25.1 24.4-.2.2-.4.3-.5.5-8.6 8.6-7 17-5.2 22.7l.3.9c7.1 17.2 17.1 33.4 32.3 52.7l.1.1c27.6 34 56.7 60.5 88.8 80.8 4.1 2.6 8.3 4.7 12.3 6.7 3.6 1.8 7 3.5 9.9 5.3.4.2.8.5 1.2.7 3.4 1.7 6.6 2.5 9.9 2.5 8.3 0 13.5-5.2 15.2-6.9l34.2-34.2c3.4-3.4 8.8-7.5 15.1-7.5 6.2 0 11.3 3.9 14.4 7.3l.2.2 55.1 55.1c10.3 10.2 10.3 20.7.1 31.3zM256.056 112.706c26.2 4.4 50 16.8 69 35.8s31.3 42.8 35.8 69c1.1 6.6 6.8 11.2 13.3 11.2.8 0 1.5-.1 2.3-.2 7.4-1.2 12.3-8.2 11.1-15.6-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3 3.7-15.6 11s3.5 14.4 10.9 15.6zM473.256 209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2 3.7-15.5 11-1.2 7.4 3.7 14.3 11.1 15.6 46.6 7.9 89.1 30 122.9 63.7 33.8 33.8 55.8 76.3 63.7 122.9 1.1 6.6 6.8 11.2 13.3 11.2.8 0 1.5-.1 2.3-.2 7.3-1.1 12.3-8.1 11-15.4z" fill="#3d2481" data-original="#000000"/>
                    </g>
                  </svg>
                </p>

                <span class="text-center">{{ $lang.messages.call }}</span>
              </a>
            </div>

            <div class="contact__item">
              <a href="https://wa.me/+62818500465" target="_blank">
                <p class="mb-0 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 682.66669 682">
                    <g fill="#3d2481">
                      <path xmlns="http://www.w3.org/2000/svg" d="M552.011719-1.332031H87.988281C39.472656-1.332031 0 38.132812 0 86.65625v283.972656c0 48.414063 39.300781 87.816406 87.675781 87.988282v128.863281l185.191407-128.863281h279.144531c48.515625 0 87.988281-39.472657 87.988281-87.988282V86.65625c0-48.523438-39.472656-87.988281-87.988281-87.988281zM602.5 370.628906c0 27.835938-22.648438 50.488282-50.488281 50.488282H261.101562l-135.925781 94.585937v-94.585937h-37.1875c-27.839843 0-50.488281-22.652344-50.488281-50.488282V86.65625c0-27.84375 22.648438-50.488281 50.488281-50.488281h464.023438C579.851562 36.167969 602.5 58.8125 602.5 86.65625zm0 0" data-original="#000000"/>
                      <path xmlns="http://www.w3.org/2000/svg" d="M171.292969 131.171875h297.414062v37.5H171.292969zm0 0M171.292969 211.171875h297.414062v37.5H171.292969zm0 0M171.292969 291.171875h297.414062v37.5H171.292969zm0 0" data-original="#000000"/>
                    </g>
                  </svg>
                </p>
                <span class="text-center">{{ $lang.messages.whats_app_message }}</span>
              </a>
            </div>

            <div class="contact__item">
              <a href="mailto:hello@ralali.com">
                <p class="mb-0 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 483.3 483.3">
                    <g fill="#3d2481" xmlns="http://www.w3.org/2000/svg">
                      <path d="M424.3 57.75H59.1c-32.6 0-59.1 26.5-59.1 59.1v249.6c0 32.6 26.5 59.1 59.1 59.1h365.1c32.6 0 59.1-26.5 59.1-59.1v-249.5c.1-32.6-26.4-59.2-59-59.2zm32.1 308.7c0 17.7-14.4 32.1-32.1 32.1H59.1c-17.7 0-32.1-14.4-32.1-32.1v-249.5c0-17.7 14.4-32.1 32.1-32.1h365.1c17.7 0 32.1 14.4 32.1 32.1v249.5h.1z" data-original="#000000"/>
                      <path d="M304.8 238.55l118.2-106c5.5-5 6-13.5 1-19.1-5-5.5-13.5-6-19.1-1l-163 146.3-31.8-28.4c-.1-.1-.2-.2-.2-.3-.7-.7-1.4-1.3-2.2-1.9L78.3 112.35c-5.6-5-14.1-4.5-19.1 1.1-5 5.6-4.5 14.1 1.1 19.1l119.6 106.9-119.1 111.5c-5.4 5.1-5.7 13.6-.6 19.1 2.7 2.8 6.3 4.3 9.9 4.3 3.3 0 6.6-1.2 9.2-3.6l120.9-113.1 32.8 29.3c2.6 2.3 5.8 3.4 9 3.4s6.5-1.2 9-3.5l33.7-30.2 120.2 114.2c2.6 2.5 6 3.7 9.3 3.7 3.6 0 7.1-1.4 9.8-4.2 5.1-5.4 4.9-14-.5-19.1l-118.7-112.7z" data-original="#000000"/>
                    </g>
                  </svg>
                </p>
                <span class="text-center">{{ $lang.messages.email }}</span>
              </a>
            </div>
          </div>

          <p
            v-if="$lang.current_lang === 'id'"
            class="font-20 mb-0 m-t-40"><span class="text-primary">Pusat layanan</span> kami siap membantu Anda kapan pun Anda butuhkan.</p>
          <p
            v-else
            class="font-20 mb-0 m-t-40">Our <span class="text-primary">customer service</span> are ready to help you at anytime.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: null
    }
  },

  methods: {
    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.user = res.user
        });
    }
  },

  async created() {
    await this.getMe()
  }
}
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  align-items: flex-start;

  &__item {
    padding: 16px 40px;
    height: 148px;

    @media screen and (max-width: 768px) {
      padding: 16px;
    }

    a {
      display: block;
    }

    span {
      display: block;
      max-width: 100px;
      margin-top: 8px;
      font-weight: bold;
      font-size: 18px;
    }
  }

  &__item + &__item {
    border-left: 2px solid #b3b3b3;
  }
}
</style>
